import { axiosNT } from '../../services/axios';


export const saveAndEditClient = (body: any, id?: string) => {
    if (id) {
        return axiosNT
            .patch(`client/${id}`, body)
    } else {
        return axiosNT
            .post(`client/`, body)
    }
}

export const saveAndEditUser = (body: any, id?: string) => {
    if (id) {
        return axiosNT
            .patch(`/user/updateUserById`, { ...body, userId: id })
    } else {
        return axiosNT
            .post(`/user/userRegister/`, body)
    }
}

export const saveAndEditRole = (body: any, id?: string) => {
    if (id) {
        return axiosNT
            .patch(`/role/updateRoleById/`, { ...body, roleId: id })
    } else {
        return axiosNT
            .post(`/role/createRoleNew`, body)
    }
}








export const getClient = (params: string) => axiosNT
    .get(`client?${params}`)

export const getUsers = (params: string) => axiosNT
    .get(`user/getClientUsers/${params}`)


export const getClientRole = (params: string) => axiosNT
    .get(`/role/getRoleByClient/${params}`)


